import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/services/auth.service";

@Injectable()
export class AuthGuard  {
  sub: Subscription;

  constructor(private auth: AuthService, private router: Router) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.auth.setRedirectUrl(state.url);
    const isLogged = await this.auth.isLogged();
    if (!isLogged) {
      this.router.navigate(["/login"]);
      return false;
    }
    return true;
  }
}
